/**
 * Scroll to the bottom of a container element with good reliability
 * @param {React.RefObject} containerRef - React ref to the container element
 */
export const scrollToBottom = (containerRef) => {
  console.log("Scrolling to bottom");
  try {
    if (containerRef.current) {
      // Use a very large value to ensure we scroll to the very bottom
      containerRef.current.scrollTop = 999999;

      // Double-check after a moment to ensure it worked
      setTimeout(() => {
        if (containerRef.current) {
          containerRef.current.scrollTop = 999999;
        }
      }, 50);
    }
  } catch (error) {
    console.error("Error scrolling to bottom:", error);
  }
};

/**
 * Scroll to top of a container element
 * @param {React.RefObject} containerRef - React ref to the container element
 */
export const scrollToTop = (containerRef) => {
  console.log("Scrolling to top");
  try {
    if (containerRef.current) {
      // Use 0 to ensure we scroll to the very top
      containerRef.current.scrollTop = 0;

      // Double-check after a moment to ensure it worked
      setTimeout(() => {
        if (containerRef.current) {
          containerRef.current.scrollTop = 0;
        }
      }, 50);
    }
  } catch (error) {
    console.error("Error scrolling to top:", error);
  }
};

/**
 * Scroll to a specific message by index
 * @param {number} messageIndex - Index of the message to scroll to
 * @param {React.RefObject} containerRef - React ref to the container element
 */
export const scrollToMessage = (messageIndex, containerRef) => {
  console.log("Scrolling to message:", messageIndex);
  try {
    // Find the element by its ID
    const messageElement = document.getElementById(`message-${messageIndex}`);
    if (!messageElement || !containerRef.current) {
      console.warn(`Message element not found: message-${messageIndex}`);
      return;
    }

    // Use absolute positioning for reliability
    const offsetTop = messageElement.offsetTop;
    containerRef.current.scrollTop = offsetTop - 100; // 100px from top for visibility

    // Highlight the message with a flash effect
    const originalBackground = messageElement.style.backgroundColor;
    const originalBorder = messageElement.style.borderLeft;
    messageElement.style.backgroundColor = 'rgba(0, 108, 219, 0.4)';
    messageElement.style.borderLeft = '3px solid rgb(0, 108, 219)';

    // Double-check the scroll position after a moment
    setTimeout(() => {
      containerRef.current.scrollTop = offsetTop - 100;

      // Reset the highlight after some time
      setTimeout(() => {
        if (messageElement) {
          messageElement.style.backgroundColor = originalBackground || 'transparent';
          messageElement.style.borderLeft = originalBorder || 'none';
        }
      }, 800);
    }, 10);
  } catch (error) {
    console.error("Error scrolling to message:", error);
  }
};

/**
 * Get or create a DOM container for a portal
 * @param {string} id - Container ID
 * @returns {HTMLElement} DOM element to use as portal container
 */
export const getPortalContainer = (id) => {
  let container = document.getElementById(id);
  if (!container) {
    container = document.createElement('div');
    container.id = id;
    document.body.appendChild(container);
  }
  return container;
};

export default {
  scrollToBottom,
  scrollToTop,
  scrollToMessage,
  getPortalContainer
}; 